import { ReactNode } from 'react';

export const BENEFIT_LOGOS: Record<string, ReactNode> = {
  skeelo: (
    <svg
      aria-label='Skeelo'
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      fill='none'
      viewBox='0 0 32 32'
    >
      <path
        fill='#00c38c'
        fillRule='evenodd'
        d='M11.142 0q.577 0 1.14.057c3.16.32 5.93 1.96 7.749 4.36l.007.01a4.25 4.25 0 0 0-2.01 3.61 4.254 4.254 0 0 0 3.196 4.119l-.003.006c4.814 1.23 8.373 5.591 8.373 10.783 0 2.173-.624 4.2-1.702 5.914-.42.668-.91 1.288-1.458 1.85A4.25 4.25 0 0 1 23.377 32a4.254 4.254 0 0 1-4.256-4.251 4.25 4.25 0 0 1 2.263-3.758l-.002-.003a4.25 4.25 0 0 0 2.247-4.162 6.88 6.88 0 0 0-5.601-2.875 6.86 6.86 0 0 0-3.63 1.033l-.049-.041a4.24 4.24 0 0 0-2.6-.99l-.02.079a4.26 4.26 0 0 0 1.355 4.187l-.002.128c0 1.074.399 2.055 1.057 2.803l-.002.002a2.629 2.629 0 0 1-1.971 4.367 2.63 2.63 0 0 1-2.614-2.32l.004-.001a6.88 6.88 0 0 0-3.615-5.218l.002-.003A11.13 11.13 0 0 1 0 11.13C0 4.983 4.989 0 11.142 0m7.774 19.167c.46 0 .892.119 1.27.326a2.64 2.64 0 0 1-3.611 1.096 2.64 2.64 0 0 1 2.34-1.422'
        clipRule='evenodd'
      />
    </svg>
  ),
};
